import { Card, CardContent, CardTitle, CardDescription } from './Card'
import { cn } from '@/lib/utils'
import { ArrowRight } from 'lucide-react'

interface SkillCardProps {
  title: string
  description: string
  imageSrc: string
  onClick?: () => void
  className?: string
}

export function SkillCard({
  title,
  description,
  imageSrc,
  onClick,
  className,
}: SkillCardProps) {
  return (
    <Card
      variant="hover"
      className={cn('h-full cursor-pointer group relative overflow-hidden', className)}
      onClick={onClick}
    >
      {/* Hover bar at top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-orange-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left z-10" />

      <div className="relative aspect-video overflow-hidden">
        <img
          src={imageSrc}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-normal"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-dark/60 to-transparent" />
      </div>
      <CardContent className="flex flex-col flex-grow">
        <CardTitle className="group-hover:text-primary transition-colors">
          {title}
        </CardTitle>
        <CardDescription className="flex-grow line-clamp-3">
          {description}
        </CardDescription>
        <div className="mt-4 flex items-center text-primary font-medium">
          <span>Leggi tutto</span>
          <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
        </div>
      </CardContent>
    </Card>
  )
}
